export default {"uiRadio":"b5sFU","active":"P72cY","fill":"_-1KS-"};